import _ from 'lodash';
import React from 'react';
import { BusinessUnitFilter, DisciplineFilter, LocationFilter, PracticeFilter, SkillFilter } from '~/components';
import { useFeatures } from '~/hooks';
import ResourceStatusFilter from '../../routes/app/resources/allocations/member-schedule/filters/ResourceStatusFilter';
import ResourceTypeFilter from '../../routes/app/resources/allocations/member-schedule/filters/ResourceTypeFilter';
import FiltersGroup from './FiltersGroup';

export default function ResourceFiltersGroup({ filters, onChange }) {
  const features = useFeatures();

  return (
    <FiltersGroup
      label="Resource Filters"
      filters={[
        filters.resourcePractices,
        filters.resourceBusinessUnits,
        filters.resourceDisciplines,
        filters.resourceLocations,
        filters.resourceSkills,
        filters.resourceStatusId,
        filters.resourceTypeId,
      ]}>
      {features.practices && _.has(filters, 'resourcePractices') && (
        <PracticeFilter
          placeholder="Resource Practice"
          value={filters.resourcePractices}
          onChange={({ target: { value } }) => onChange({ resourcePractices: value })}
        />
      )}

      {features.businessUnits && _.has(filters, 'resourceBusinessUnits') && (
        <BusinessUnitFilter
          placeholder="Resource Business Unit"
          value={filters.resourceBusinessUnits}
          onChange={({ target: { value } }) => onChange({ resourceBusinessUnits: value })}
        />
      )}

      {features.disciplines && _.has(filters, 'resourceDisciplines') && (
        <DisciplineFilter
          placeholder="Resource Discipline"
          value={filters.resourceDisciplines}
          onChange={({ target: { value } }) => onChange({ resourceDisciplines: value })}
        />
      )}

      {_.has(filters, 'resourceLocations') && (
        <LocationFilter
          placeholder="Resource Location"
          value={filters.resourceLocations}
          onChange={({ target: { value } }) => onChange({ resourceLocations: value })}
        />
      )}

      {_.has(filters, 'resourceSkills') && (
        <SkillFilter
          placeholder="Resource Skills"
          value={filters.resourceSkills}
          onChange={({ target: { value } }) => onChange({ resourceSkills: value })}
        />
      )}

      {_.has(filters, 'resourceStatusId') && (
        <ResourceStatusFilter
          value={filters.resourceStatusId}
          onChange={({ target: { value } }) => onChange({ resourceStatusId: value })}
        />
      )}

      {_.has(filters, 'resourceTypeId') && (
        <ResourceTypeFilter
          value={filters.resourceTypeId}
          onChange={({ target: { value } }) => onChange({ resourceTypeId: value })}
        />
      )}
    </FiltersGroup>
  );
}
